__webpack_require__.p = "/tournament-tracker/";